import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Clients',
  basePath: '/clients',
  rowKey: 'pid',
  columns: [
    { key: 'company', label: 'Company', sortable: true },
    { key: 'client_type_name', label: 'Client Type', sortable: true },
    { key: 'countries_list', label: 'Countries' },
    { key: 'key_accounts_list', label: 'Key Accounts' },
  ],
  fields: [
    { key: 'company', label: 'Company', type: 'text', required: true },
    { key: 'client_type', label: 'Client Type', type: 'async-select',
      optionsUrl: '/clients-type/options',
      placeholder: 'Select client type' },
    { key: 'countries', label: 'Countries', type: 'multi-relation',
      engine: 'searchable-multi', optionsUrl: '/countries/options' },
    { key: 'key_accounts', label: 'Key Accounts', type: 'multi-relation',
      engine: 'searchable-multi', optionsUrl: '/users-admin/options' },
    { key: 'related_clients', label: 'Related Clients', type: 'multi-relation',
      engine: 'searchable-multi', optionsUrl: '/clients/options' },
  ],
  defaultSort: { field: 'company', dir: 'asc' },
});
